import { SoggettoDto } from "@api/client";
import { subjectGetDetails, subjectSetTitolariEffettiviAdded } from "common/_redux/subject/actions";
import { legaleRappresentanteSelector } from "common/_redux/subject/selectors";
import BftAccordion from "common/components/accordion";
import DettaglioPianoCard from "common/components/dettaglio-piano-card";
import RiepilogoTitolariCard from "common/components/riepilogo-titolari";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import Header from "layout/components/header";
import Topbar from "layout/components/topbar";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";

import VerificaIdentita from "pages/onBoarding/step-3/_common-components/verifica-identita";
import useReopenNavigate from "../hooks/reopenNavigate";

const title = "Identificazione Legale Rappresentante";
const subtitle = "Identificati.";

const ReopenIdentificazioneLR: React.FC = () => {
	const dispatch = useAppDispatch();
	const reopenNavigate = useReopenNavigate();

	const rappresentanteLegale = useAppSelector(legaleRappresentanteSelector);

	const isCompleted: boolean = false;

	const goNext = () => {
		reopenNavigate?.goNext();
	};

	const getSubjects = () => {
		dispatch(subjectGetDetails())
			.unwrap()
			.then((subjectRes) => {
				if (subjectRes?.elencoTitolariEffettivi?.length) {
					const esponentiMapped = subjectRes.elencoTitolariEffettivi?.map((item: SoggettoDto) => ({
						...item,
						idFE: item.id,
						fulfilled: item.fullfiled,
					}));
					dispatch(
						subjectSetTitolariEffettiviAdded({
							list: esponentiMapped,
						})
					);
				}
			});
	};

	useEffect(() => {
		getSubjects();
	}, []);

	return (
		<>
			<div className="verifica-identita-page">
				<div className="d-flex flex-column min-vh-100">
					<div className="body flex-grow-1 px-0">
						<Header />
						<Topbar />

						<div className="container-fluid body-section px-0">
							<section>
								<Row>
									<Col sm={12} lg={8}>
										<div>
											<h2 className="mb-3 ms-3">{title}</h2>
											<span className="gray">{subtitle}</span>
										</div>

										<BftAccordion
											title={`Verifica l'identità di ${rappresentanteLegale?.nome} ${rappresentanteLegale?.cognome} `}
											index={1}
											total={1}
											isActive={!isCompleted}
											isCompleted={isCompleted}
										>
											<>
												<div>
													<VerificaIdentita
														subjectDetails={rappresentanteLegale}
														onComplete={() => goNext()}
														skipSaveStepStatus
													/>
												</div>
											</>
										</BftAccordion>
									</Col>

									<Col sm={12} md={4} className="side-card">
										<DettaglioPianoCard />
										<RiepilogoTitolariCard />
									</Col>
								</Row>
							</section>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
export default ReopenIdentificazioneLR;
